import { z } from "zod";

export const GetMagicLinkConfigInputSchema = z.object({
    requestId: z.string().nullish(),
});

export type GetMagicLinkConfigInput = z.infer<typeof GetMagicLinkConfigInputSchema>;

